import { NavigationStart, Router, Event as NavigationEvent  } from '@angular/router';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivityService } from './shared/activity.service';
import { MessageService } from './shared/message.service';
import { AlertTypes, MessageType } from './shared/messageType';
import { NgbAlert, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TimeoutWarningComponent } from './timeout-warning/timeout-warning.component';
import { SecurityService } from './shared/security.service';
import { ModalService } from './shared/modal.service';
import { NavbarService } from './primary-nav/primary-nav.service';
import { Alert, AlertType } from './shared/alert.model';
import { CustomerSupportService } from './customer-support/services/customer-support.service';
import { firstValueFrom } from 'rxjs';
import { IdmUtilities} from '@platform-idm/sdk-javascript';
import { PlatformIdmService } from '@platform-idm/sdk-angular';

@Component({
    selector: 're-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'app';
  isAuthenticated: boolean;
  warningRef: NgbModalRef;
  processing = false;
  refreshTokenInterval;
  isFederatedUser : boolean;
  alert: Alert;
  alertClass = "alert-success";
  showMenu = true;

  @ViewChild('genericFloatingAlert') floatingAlert: ElementRef;

  constructor(
    private router: Router,
    private activityService: ActivityService,
    private messages: MessageService,
    private modalService: NgbModal,
    private securityService: SecurityService,
    private mcModal: ModalService,
    public nav: NavbarService,
    private customerSupportService: CustomerSupportService,
    private authService: PlatformIdmService
  ) {


    //lets keep the subscription on the consturctor so it executes before any child component,
    // and so they can send events before app.component is initted.
    this.messages.get().subscribe((msg) => {

      //this timeout will prevent the ExpressionChangedAfterItHasBeenCheckedError:  error during development
      setTimeout(() => {
        if (msg == MessageType.HideMenu) {
          this.showMenu = false;
        }
        if (msg == MessageType.Authenticated) {
          this.isAuthenticated = true;
        }
        if (msg.isGenericMessage) {


          if (msg.type === AlertTypes.Success) {
            this.alert = new Alert(AlertType.SUCCESS, msg.message);
            this.alertClass = "alert-success";
            this.startAlertTimer();
          }
          else if (msg.type === AlertTypes.Warning) {
            this.alert = new Alert(AlertType.WARNING, msg.message);
            this.alertClass = "alert-warning";
            this.startAlertTimer();
          }
          else if (msg.type === AlertTypes.Error) {
            this.alert = new Alert(AlertType.DANGER, msg.message);
            this.alertClass = "alert-danger";
          }
          else if (msg.type === AlertTypes.Clear) {
            this.alert = null;
          }
          else if (msg.type === AlertTypes.ClearError) {
            this.clearErrorAlert();
          }
          return;
        }


        if (msg === MessageType.Logout) {
          this.logout();
        } else if (msg === MessageType.ProcessingOn) {
          this.processing = true;
        } else if (msg === MessageType.ProcessingOff) {
          this.processing = false;
        }
      });


    });



  }

  private clearErrorAlert() {
    if (this.alert && this.alert.type == AlertType.DANGER) {
      this.alert = null;
    }
  }

  private startAlertTimer() {
    setTimeout(() => {
      this.alert = null;
    }, 3000);
  }
  previousToken = "";




  async ngOnInit() {
    await this.authService.configure();


    this.router.events.subscribe(
      (event: NavigationEvent) => {
        if (event instanceof NavigationStart) {
          this.clearErrorAlert();
        }
      });




    this.isAuthenticated = await this.securityService.isAuthenticated();
    this.securityService.isFederatedUser().subscribe(x => this.isFederatedUser = x);
    if (this.isAuthenticated) {


      if (!await this.securityService.hasSomeRights()) {
        this.router.navigateByUrl('/permissionsRequired');
        return;
      }

      if (this.router.url === '/login') {
        this.securityService.navigateToHome();
      }
    }




    //let isSupport = await this.securityService.isSupportUser().toPromise();
    //if (isSupport)
    //{
    //  //handle the tab close, window close and window refresh!!!!!
    //  window.addEventListener("beforeunload", async (x) => {

    //    //lets not delete the user on window refresh
    //    //is page refreshing (session storage check?)
    //    await this.customerSupportService.deleteCustomer().toPromise();
    //    //delete flag form session storage?
    //  });
    //}

    this.messages.send(MessageType.AppCInitLoaded);
  }


	  async logout() {
	    try {
	      let isViewAnyCustomer = await firstValueFrom(this.securityService.isCanViewAnyCustomer());
	      if (isViewAnyCustomer) {
	        await firstValueFrom(this.customerSupportService.deleteCustomer());
	      }
	    } catch (e) { // ignore failures so the logout can continue
	      // swallow errors so logout can proceed
	    }

	    // Populate federated logout URL state based on current settings.
	    await this.securityService.isDUOFederated();

	    const federatedLogoutUrl = this.securityService.getFederatedLogoutUrl();

	    if (federatedLogoutUrl) {
	      // Any federated provider (DUO or others like Azure) with SLO enabled
	      // will be routed through the /slologout page, which will then
	      // redirect to the IdP logout URL stored in localStorage.
	      localStorage.setItem('duoLogoutUrl', federatedLogoutUrl);
	      await this.authService.authentication.logout("/slologout?sloRedirect=true");
	    } else {
	      // No SLO/logout URL configured. Fall back to standard application logout.
	      await this.authService.authentication.logout("/");
	    }
	  }

  // Open DUO logout tab
  openDuoLogoutTab(){
    const duoLogoutUrl = this.securityService.getDuoLogoutUrl();
    if (duoLogoutUrl) {
      const newTab = window.open(duoLogoutUrl, '_blank', 'noopener,noreferrer');
      if(newTab){
        newTab.opener = null;
      }
    }
  }
}
let AdminToolVersion = '2020-05-18 15:57'; //Use this to force an angular build, casuing a rehash of the main.js file
